import { LINK_FIRST_INVITE } from "./props";
import { useIsFeatureEnabled } from "./useIsFeatureEnabled";

export function useLinkFirstInvite() {
  return useIsFeatureEnabled(LINK_FIRST_INVITE);
}
